"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentCollaborativeCulminatingMoment = getCurrentCollaborativeCulminatingMoment;
exports.getDocumentBeingGraded = getDocumentBeingGraded;
exports.getNextDocumentToGrade = getNextDocumentToGrade;
exports.getTeamIdForDocument = getTeamIdForDocument;
var _missionStateConstants = require("../constants/missionStateConstants");
var _general = require("./general");
/**
 * getCurrentCollaborativeCulminatingMoment - get the current collaborative culminating moment screen
 *
 * @param {ReduxStore} state - the current redux state
 *
 * @return {?string} - the current collaborative culminating moment screen (or null/undefined if the current screen is not a collaborative culminating moment)
 */
function getCurrentCollaborativeCulminatingMoment(missionState) {
  let launchpadScreen = (0, _general.getScreenFromMission)(missionState);
  if (launchpadScreen?.type !== 'COLLABORATIVE_CULMINATING_MOMENT_SCREEN') {
    return null;
  }
  return launchpadScreen;
}

/**
 * getDocumentBeingGraded - get the id of the document currently being graded
 *
 * @param {ReduxStore} state - the current redux state
 *
 * @return {?string} - the id of the document currently being graded (or null/undefined if there is no document being graded)
 */
function getDocumentBeingGraded(missionState) {
  const collaborativeCulminatingMoment = getCurrentCollaborativeCulminatingMoment(missionState);
  if (!collaborativeCulminatingMoment) {
    return null;
  }
  let currentStep = collaborativeCulminatingMoment.currentStep;
  if (!(currentStep.status === _missionStateConstants.COLLABORATIVE_CULMINATING_MOMENT.SCREEN_STATUS.GRADING_ALL || currentStep.status === _missionStateConstants.COLLABORATIVE_CULMINATING_MOMENT.SCREEN_STATUS.GRADING_HIDDEN || currentStep.status === _missionStateConstants.COLLABORATIVE_CULMINATING_MOMENT.SCREEN_STATUS.GRADING_UNHIDDEN)) {
    return null;
  }
  return currentStep.currentlyGrading;
}

/**
 * getNextDocumentToGrade - gets the id of the next document to grade
 *
 * @param {?SharedMissionStateSelectorState} missionState - the current state of the mission
 *
 * @return {?string} the id of the next document to grade or null/undefined if there is not a next document to grade
 */
function getNextDocumentToGrade(missionState) {
  const collaborativeCulminatingMoment = getCurrentCollaborativeCulminatingMoment(missionState);
  if (!collaborativeCulminatingMoment) {
    return null;
  }
  let currentStep = collaborativeCulminatingMoment.currentStep;
  if (!(currentStep.status === _missionStateConstants.COLLABORATIVE_CULMINATING_MOMENT.SCREEN_STATUS.GRADING_ALL || currentStep.status === _missionStateConstants.COLLABORATIVE_CULMINATING_MOMENT.SCREEN_STATUS.GRADING_HIDDEN || currentStep.status === _missionStateConstants.COLLABORATIVE_CULMINATING_MOMENT.SCREEN_STATUS.GRADING_UNHIDDEN)) {
    return null;
  }
  const currentlyGrading = currentStep.currentlyGrading;
  if (!currentlyGrading) {
    // edge case - there is not document to grade, consider it as being the last document
    return null;
  }
  const currentlyGradingIndex = currentStep.qualifiedDocuments.findIndex(({
    documentId
  }) => documentId === currentlyGrading);
  if (currentlyGradingIndex < 0 || currentlyGradingIndex === currentStep.qualifiedDocuments.length - 1) {
    // edge case - there document being graded does not exist, consider it the last document to grade
    return null;
  }
  return currentStep.qualifiedDocuments[currentlyGradingIndex + 1].documentId;
}

/**
 * Gets the team id for the given `documentId`
 */
function getTeamIdForDocument(state, documentId) {
  const canvases = state?.stationData.creativeCanvas.canvases;
  for (const canvasId in canvases) {
    const team = canvases[canvasId].teams.find(t => t.document.id === documentId)?.teamId;
    if (team) return team;
  }
}